/**
 * Converts a Python f-string template to Mustache syntax
 * @param template - The f-string template to convert
 * @returns The converted Mustache template
 *
 * Examples:
 * f"Hello {name}" -> "Hello {{name}}"
 * f"The {count} items cost ${price:.2f}" -> "The {{count}} items cost ${{price}}"
 * f"{user.name}'s {item.type}" -> "{{user.name}}'s {{item.type}}"
 */
export function convertFStringToMustache(template: string): string {
  // Handle nested expressions and format specifiers
  return template.replace(/\{([^}]+)\}/g, (_, expression) => {
    // Remove any format specifiers (e.g., :.2f)
    const cleanExpression = expression.split(':')[0];

    // Handle simple expressions
    return `{{${cleanExpression}}}`;
  });
}

export function convertMustacheToFString(template: string): string {
  return template.replace(/\{\{([^}]+)\}\}/g, (_, expression) => {
    return `{${expression}}`;
  });
}

export function toggleTemplateFormat(
  template: string,
  currentFormat: 'f-string' | 'mustache'
): string {
  return currentFormat === 'f-string'
    ? convertFStringToMustache(template)
    : convertMustacheToFString(template);
}
